import { createSelector, createStructuredSelector } from 'reselect';
import { getFilteredStops, getSelectedPreparedStops } from './stopFilters';
import MOVE_TYPES from '../../../../enums/moveTypes';
import {
  isMergeDisabled,
  isMoveStopEnabled,
  isMoveToEnable,
  isParcelTransferDisabled,
  isStopTransferDisabled,
} from '../../../../models/routeDetail';
import * as sortStopsModel from '../../../../models/sortStops';
import {
  hasRouteUnprocessedRequest,
  isCurrentRouteHasRequestWithoutResponse,
  isRouteStatusInBuild,
} from '../../route';
import { getSelectedParcels } from './selectedParcels';

export const getStopListOrder = (state) => state.ui.routeDetail.stopListOrder;

const isMoveButtonDisabled = (direction) =>
  createSelector(
    getSelectedPreparedStops,
    getFilteredStops,
    getStopListOrder,
    isRouteStatusInBuild,
    (selectedStops, filteredStops, stopListOrder, isRouteStatusInBuild) =>
      !isMoveStopEnabled(
        direction,
        selectedStops,
        filteredStops,
        stopListOrder,
        isRouteStatusInBuild
      )
  );

export const getMoveButtonsDisabledState = createStructuredSelector({
  [MOVE_TYPES.UP]: isMoveButtonDisabled(MOVE_TYPES.UP),
  [MOVE_TYPES.DOWN]: isMoveButtonDisabled(MOVE_TYPES.DOWN),
});

export const getMoveToButtonDisabledState = createSelector(
  getSelectedPreparedStops,
  getStopListOrder,
  isRouteStatusInBuild,
  (selectedStops, stopListOrder, isRouteStatusInBuild) =>
    !isMoveToEnable(selectedStops, stopListOrder, isRouteStatusInBuild)
);

export const getMergeButtonDisableState = createSelector(
  getSelectedPreparedStops,
  isRouteStatusInBuild,
  isMergeDisabled
);

export const getStopTransferDisabledState = createSelector(
  getSelectedPreparedStops,
  isRouteStatusInBuild,
  isCurrentRouteHasRequestWithoutResponse,
  (selectedStops, isRouteInBuild, requestWithNoResponse) =>
    isRouteInBuild ||
    requestWithNoResponse ||
    isStopTransferDisabled(selectedStops)
);

export const getParcelTransferDisabledState = createSelector(
  getSelectedPreparedStops,
  getSelectedParcels,
  isRouteStatusInBuild,
  isCurrentRouteHasRequestWithoutResponse,
  (selectedStops, parcels, isRouteInBuild, requestWithNoResponse) =>
    isRouteInBuild ||
    requestWithNoResponse ||
    isParcelTransferDisabled(parcels, selectedStops[0])
);

export const getRemoveParcelsDisabledState = createSelector(
  isRouteStatusInBuild,
  hasRouteUnprocessedRequest,
  (isRouteInBuild, hasUnProcessedRequest) =>
    isRouteInBuild || hasUnProcessedRequest
);

export const getSortedStops = createSelector(
  getFilteredStops,
  getStopListOrder,
  sortStopsModel.getSortedStops
);
